<template>
  <div class="pt-16 h-screen bg-front-page-background">
    <div class="max-w-xs mx-auto">
      <div class="text-center hidden sm:block logo-container bg-front-page-background"></div>
      <div class="text-center ml-0 hidden sm:block text-2xl front-text-color bg-front-page-background">Members Hub</div>
      <div v-if="passwordReset" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 mt-4">
        <p class="leading-tight mb-4">
          You will shortly recieve an email containing your password reset link
        </p>
        <router-link to="login" class="inline-block no-underline bg-front-page-background hover:bg-tertiary text-white font-bold py-2 px-4 rounded">
          Login
        </router-link>
      </div>
      <form v-else @submit="reset" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 mt-4">
        <div class="mb-4">
          <label
            class="block text-grey-darker text-sm font-bold mb-2"
            for="email"
          >
            Email
          </label>
          <input
            class="shadow appearance-none border rounded w-full mb-2 py-2 px-3 text-grey-darker leading-tight"
            id="email"
            type="email"
            placeholder="me@example.com"
            v-model="email"
          >
          <!-- required -->
          <small
            v-if="errorBag.get('email')"
            class="text-red-dark"
          >
            {{ errorBag.get('email') }}
          </small>
        </div>
        <div class="flex items-center justify-between">
          <button
            class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded"
            type="submit"
            :disabled="resetting"
            :class="{ 'opacity-50': resetting }"
          >
            Reset Password
          </button>
          <router-link
            to="login"
            class="inline-block align-baseline font-bold text-sm text-grey hover:text-grey-darker"
            :disabled="resetting"
          >
            Cancel
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ErrorBag from '@/ErrorBag'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      errorBag: new ErrorBag(),
      email: null,
      resetting: false,
      passwordReset: false
    }
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    reset (e) {
      e.preventDefault()
      this.errorBag.clear()
      this.resetting = true

      axios
        .post(process.env.VUE_APP_ROOT_API + '/password/email', {
          email: this.email
        })
        .then(response => {
          console.log(response)
          this.resetting = false
          this.passwordReset = true
        })
        .catch(error => {
          this.resetting = false
          this.errorBag.store(error.response.data)
        })
    }
  }
}
</script>
